import React from "react";
import addonIcon from "../../../../img/addonIcon.png";

import ItemCatalogue_NoViewAll from "../../../../User/Home/Components/Homepage/HomePageSelectItems/ItemCatalogue_NoViewAll";
const LastMinAddOn = () => {
  return (
    <>
      <ItemCatalogue_NoViewAll
        title="Your last minute add-ons"
        param="getCategoriesProduct/trending"
        titleImage={addonIcon}
      />
    </>
  );
};

export default LastMinAddOn;
